<!-- 组件说明 -->
<template>
  <div class="buy-ratio-item">
    <div class="title" v-if="type === 'sale'">{{ toYear }}年老带新认购占比</div>
    <div class="title" v-if="type === 'deal'">{{ toYear }}年老带新签约占比</div>
    <div
      class="ratio"
      :style="{ color: type === 'sale' ? ' #0d9869' : '#D2992E' }"
    >
      <span class="ratio-num">{{
        type === "sale"
          ? stringFloatPercent(statisticsData.ldxSubscribePercentage)
          : stringFloatPercent(statisticsData.ldxSigningPercentage)
      }}</span>
      <span class="ratio-icon">%</span>
    </div>
    <div class="progress">
      <van-progress
        :percentage="
          type === 'sale'
            ? stringFloatPercent(statisticsData.ldxSubscribePercentage)
            : stringFloatPercent(statisticsData.ldxSigningPercentage)
        "
        pivot-text=" "
        stroke-width="6"
        :text-color="type === 'sale' ? '#0D9869' : '#D89D2F'"
        :pivot-color="type === 'sale' ? '#0D9869' : '#D89D2F'"
        :track-color="type === 'sale' ? '#EEF6F3' : '#FAF2E5'"
        :color="
          type === 'sale'
            ? 'linear-gradient(to left, #1EC9A2, #0D9869)'
            : 'linear-gradient(to left, #FFE0A9, #D89D2F)'
        "
      />
    </div>
    <div class="sale-num">
      <div v-if="type === 'sale'">老带新认购套数</div>
      <div v-if="type === 'deal'">老带新签约套数</div>
      <div>
        <span class="num">{{
          type === "sale"
            ? parseInt(statisticsData.ldxSubscribeTotal)
            : parseInt(statisticsData.ldxSigningTotal)
        }}</span>
        <span class="case">套</span>
      </div>
    </div>
    <div class="sale-num">
      <div v-if="type === 'sale'">总认购套数</div>
      <div v-if="type === 'deal'">总签约套数</div>
      <div>
        <span class="num">{{
          type === "sale"
            ? parseInt(statisticsData.subscribeTotal)
            : parseInt(statisticsData.signingTotal)
        }}</span>
        <span class="case">套</span>
      </div>
    </div>
  </div>
</template>

<script>
import { Progress as VanProgress } from "vant";
export default {
  props: {
    type: {
      type: String,
    },
    statisticsData: {
      type: Object,
    },
    toYear: String,
  },
  components: { VanProgress },
  methods: {
    stringFloatPercent(string) {
      if (!string) {
        string = 0;
      }
      return Math.floor(parseFloat(string) * 10000) / 100;
    },
  },
  watch: {
    toYear(v) {
      this.toYear = v;
    },
  },
};
</script>

<style lang="scss" scoped>
.buy-ratio-item {
  width: 330px;
  height: 324px;
  background: #ffffff;
  border-radius: 16px;
  border: 2px solid #f2f2f2;
  padding: 24px 10px;
  .title {
    height: 34px;
    line-height: 34px;
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    text-align: center;
  }
  .ratio {
    height: 56px;
    color: #0d9869;
    text-align: center;
    margin-top: 12px;
    .ratio-num {
      font-size: 40px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      line-height: 56px;
    }
    .ratio-icon {
      font-size: 24px;
    }
  }
  .progress {
    margin: 16px 0 30px;
    padding: 0 10px;
    ::v-deep .van-progress__portion {
      border-top-left-radius: inherit;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      border-bottom-left-radius: inherit;
    }
    ::v-deep .van-progress__pivot {
      padding: 0;
      min-width: 1px;
      height: 24px;
    }
  }
  .sale-num {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 52px;

    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    padding: 0 16px;
    .num {
      color: #333333;
      font-size: 28px;
    }
    .case {
      color: #999999;
      font-size: 24px;
    }
  }
}
</style>
